import { useState, useEffect } from "react";
import { Table } from "antd";
import { fbGetAllGroupDetails } from "../../../services/firebaseService/endPoints/group";
import { getDeactivatedUsers } from "../../../services/firebaseService/endPoints/user";
import { ScreenHeader } from "../../../CommonComponents";
import SuperAdminContainer from "../SuperAdminContainer";

const columns = [
  {
    title: "Group Name",
    key: "groupName",
    className: "header-white",
    dataIndex: "groupName",
  },
  {
    title: "UserId",
    key: "userId",
    className: "header-white",
    dataIndex: "id",
  },
  {
    title: "Full Name",
    key: "fullName",
    className: "header-white",
    dataIndex: "name",
  },
  {
    title: "Email",
    key: "email",
    className: "header-white",
    dataIndex: "email",
  },
];

const Deactivated = () => {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchDeactivatedUsers = (groupIdDetailsMap) => {
    setIsLoading(true);
    getDeactivatedUsers()
      .then((fetchedUsers) => {
        const tableData = [];
        fetchedUsers.forEach((user) => {
          user.groupIds.forEach((groupId) => {
            const groupName = groupIdDetailsMap?.[groupId]?.groupName;
            tableData.push({ groupName, ...user });
          });
        });
        setUsers(tableData);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    const rootEl = document.querySelector(":root");
    rootEl.style.setProperty("--main-color", "#000000");

    const elements = document.querySelectorAll("th");
    elements.forEach((elem) => {
      elem.style.backgroundColor = "#000000";
    });

    fbGetAllGroupDetails().then((groups) => {
      const groupIdDetailsMap = {};
      groups.forEach((group) => {
        groupIdDetailsMap[group.id] = group;
      });
      fetchDeactivatedUsers(groupIdDetailsMap);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <SuperAdminContainer>
      <ScreenHeader title="Deactivated Users" elementCount={users.length} />
      <Table
        columns={columns}
        dataSource={users}
        className="table-backdrop mb-3"
        bordered
        loading={isLoading}
        rowKey={(record) => `${record.id}-${record.groupName}`}
        bodyStyle={{
          fontSize: window.innerWidth > 500 ? "18px" : "12px",
          backgroundColor: "#ffffff",
        }}
        pagination={{
          defaultPageSize: 50,
          showSizeChanger: true,
          pageSizeOptions: [10, 20, 50, 100],
        }}
      />
    </SuperAdminContainer>
  );
};

export default Deactivated;
